<template>
  <div class="columns" v-if="service && occurrence">
    <div class="is-half column">
      <service :service="service"></service>
    </div>
    <div class="is-half column">
      <occurrences-simple :service="service" :occurrence="occurrence.id"></occurrences-simple>
      <br>
      <occurrences-simple :service="service" :occurrence="occurrence.id" :internal="true" v-if="parseInt($store.state.config.user.level) < 4"></occurrences-simple>
      <br>
      <article class="tile is-child box">
        <h4 class="title">Ticket <span v-if="parseInt(occurrence.type) == 2">Internal</span> - {{ occurrence.team_user !== null ? occurrence.team_user.name : 'Not Allocated'}}</h4>
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="card is-fullwidth" style="box-shadow: 0 2px 3px #A71C20, 0 0 0 1px #A71C20;">
              <header class="card-header is-primary" style="box-shadow: 0 1px 0px #A71C20, 0 0 0 0px #A71C20; background-color: #A71C20; display: flex; align-items: center;">
                <p class="card-header-title is-primary" style="color: #FFFFFF;">#{{ occurrence.id }} - {{ occurrence.subject }}</p>
                <!--botão para reabrir ticket-->
                <button style="margin-right: 0.5rem;" v-show="occurrence.status == 3 && (parseInt($store.state.config.user.level) == 3)" class="button is-warning is-small"  @click="reopenOccurrence">Reopen</button>
              </header>
              <div class="card-content">
                <div class="content">
                  <article class="media">
                    <p>
                      <b>Department:</b> {{ parseDepartament(occurrence.departament)}}<br/>
                      <b>Status:</b> {{ parseStatus(occurrence.status) }}<br/>
                    </p>
                  </article>
                  <article class="media">
                    <pre v-html="occurrence.occurrence"></pre>
                  </article>
                  <article class="media" v-if="occurrence.files.length > 0">
                    <template v-if="showFiles == false">
                      <a class="button" @click="loadFiles"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show Files ({{occurrence.files.length}})</span></a>
                    </template>
                    <template v-else>
                      <div class="columns is-multiline">
                        <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                        <template v-for="file in occurrence_files">
                          <div class="column is-12" style="text-align: center;">
                            <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                              <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                <img :src="file['url']" alt="" width="90%">
                              </a>
                            </template>
                            <template v-else>
                                <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                  <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                  {{file['name']}}
                                </a>
                            </template>
                          </div>
                          <div class="column is-12">
                            <article class="media">
                            </article>
                          </div>
                        </template>
                      </div>
                    </template>
                  </article>
                  <p>
                    <template v-if="occurrence.email != null && parseInt(occurrence.user_id) == 1">
                      <small class="is-pulled-right"><b>{{ occurrence.email_name }} ({{occurrence.email}})</b> at <b>{{ occurrence.created_at }}</b>
                      </small>
                    </template>
                    <template v-else>
                      <small class="is-pulled-right"><b>{{ occurrence.user.name }}</b> at <b>{{ occurrence.created_at }}</b></small>
                      <br>
                      <small class="is-pulled-right">Contact Name: <b>{{ occurrence.contact_name }}</b> Contact Phone: <b>{{ occurrence.contact_phone }}</b></small>
                    </template>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <template v-for="(reply, index) in occurrence.replies">
            <template v-if="parseInt(reply.type) == 2">
              <template v-if="parseInt($store.state.config.user.level) < 4">
                <div class="column is-12">
                  <div class="card is-fullwidth tip">
                    <header class="card-header is-primary" style="box-shadow: 0 1px 0px #2366d1, 0 0 0 0px #2366d1; background-color: #2366d1;">
                      <p class="card-header-title is-primary" style="color: #FFFFFF;">Internal Tip</p>
                    </header>
                    <div class="card-content">
                      <div class="content">
                        <pre v-html="reply.reply"></pre>
                        <article class="media" v-if="reply.files.length > 0">
                        </article>
                        <article class="media" v-if="reply.files.length > 0">
                          <template v-if="reply.showFiles == false">
                            <a class="button" @click="loadFilesReply(reply, index)"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show attachments ({{reply.files.length}})</span></a>
                          </template>
                          <template v-else>
                              <div class="columns is-multiline">
                                <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                                <template v-for="file in reply.files">
                                  <div class="column is-12" style="text-align: center;">
                                    <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                                      <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                        <img :src="file['url']" alt="" width="90%">
                                      </a>
                                    </template>
                                    <template v-else>
                                        <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                          <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                          {{file['name']}}
                                        </a>
                                    </template>
                                  </div>
                                  <div class="column is-12">
                                    <article class="media">
                                    </article>
                                  </div>
                                </template>
                              </div>
                          </template>
                        </article>
                        <p>
                          <template v-if="occurrence.email != null && parseInt(reply.user_id) == 1">
                            <small class="is-pulled-right"><b>{{ occurrence.email_name }} ({{occurrence.email}})</b> at <b>{{ reply.created_at }}</b>
                            </small>
                          </template>
                          <template v-else>
                            <small class="is-pulled-right"><b>{{ reply.user.name }}</b> at <b>{{ reply.created_at }}</b>
                            </small>
                          </template>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="column is-12">
                <div class="card is-fullwidth">
                  <div class="card-content">
                    <div class="content">
                      <pre v-html="reply.reply"></pre>
                      <article class="media" v-if="reply.files.length > 0">
                      </article>
                      <article class="media" v-if="reply.files.length > 0">
                        <template v-if="reply.showFiles == false">
                          <a class="button" @click="loadFilesReply(reply, index)"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show attachments ({{reply.files.length}})</span></a>
                        </template>
                        <template v-else>
                            <div class="columns is-multiline">
                              <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                              <template v-for="file in reply.files">
                                <div class="column is-12" style="text-align: center;">
                                  <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                                    <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                      <img :src="file['url']" alt="" width="90%">
                                    </a>
                                  </template>
                                  <template v-else>
                                      <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                        <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                        {{file['name']}}
                                      </a>
                                  </template>
                                </div>
                                <div class="column is-12">
                                  <article class="media">
                                  </article>
                                </div>
                              </template>
                            </div>
                        </template>
                      </article>
                      <p>
                        <template v-if="occurrence.email != null && parseInt(reply.user_id) == 1">
                          <small class="is-pulled-right"><b>{{ occurrence.email_name }} ({{occurrence.email}})</b> at <b>{{ reply.created_at }}</b>
                          </small>
                        </template>
                        <template v-else>
                          <small class="is-pulled-right"><b>{{ reply.user.name }}</b> at <b>{{ reply.created_at }}</b>
                          </small>
                        </template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
          <div class="column is-12" v-if="parseInt($store.state.config.user.level) < 4 || occurrence.status != 3">
            <div class="card is-fullwidth">
              <header class="card-header">
                <p class="card-header-title is-primary">Reply</p>
              </header>
              <div class="card-content">
                <div class="content">
                  <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
                  <div class="control is-vertical">
                    <div class="control">
                      <textarea :class="{'textarea': true, 'is-danger': errors.has('reply') }" name="reply" id="reply" placeholder="" v-model="reply.reply" v-validate data-vv-rules="required"></textarea>
                      <span v-show="errors.has('reply')" class="help is-danger">{{ errors.first('reply') }}</span>
                    </div>
                  </div>
                  <div class="control is-grouped">
                    <p class="control is-expanded">
                      <vue-dropzone ref="dropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-queue-complete="vdSuccess" @vdropzone-sending="vdSendingEvent"></vue-dropzone>
                    </p>
                  </div>
                  <template v-if ="(parseInt($store.state.config.user.level) < 4) && (service.payment_services_v2 || service.invoice_services_v2)" >
                    <div class="is-clearfix" v-if="[14].includes(parseInt(occurrence.subject_type)) && !occurrence.dispute_id && ((service.payment_services_v2) || (service.invoice_services_v2))">
                      <div class="control is-grouped">
                        <p v-if="(parseInt(service.dispute_v2) === 0) && occurrence.status !== 3 && !occurrence.financial_id" class="control">
                          <label class="label">Address to</label>
                          <select style="margin-right: 10px;" class="select is-pulled-right" v-model="dispute.address_to">
                            <option value="3">All</option>
                            <option value="1">Customer</option>
                            <option value="2">Supplier</option>
                          </select>
                        </p>
                        <a style="margin-top: 25px;" v-if="(parseInt(service.dispute_v2) === 0) && occurrence.status !== 3 && !occurrence.financial_id" :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="openDispute()">Open Dispute</a>
                      </div>
                    </div>
                    <charge
                      v-if="(!occurrence.financial_id && occurrence.status !== 3) && [1, 2, 3, 4, 6, 7, 8, 9, 11, 13, 17, 19, 31].includes(parseInt(occurrence.subject_type))"
                      :occurrence="occurrence"
                      :context="this">
                      <!-- :type="[3, 4, 6, 11].includes(parseInt(occurrence.subject_type)) ? [3, 6, 11, 9].includes(parseInt(occurrence.subject_type)) ? parseInt(2) : parseInt(1) : null" -->
                    </charge>
                    <div class="is-clearfix" v-if="([18].includes(parseInt(occurrence.subject_type)) && !occurrence.financial_id)">
                      <div class="control is-grouped">
                        <p class="control">
                          <label class="label">Type</label>
                          <select style="margin-right: 10px;" class="select is-pulled-right" v-model="charge.type">
                            <option value="1">Commission</option>
                            <option value="2">Cre/Deb</option>
                          </select>
                        </p>
                        <p class="control">
                          <label class="label">Address to</label>
                          <select style="margin-right: 10px;" class="select is-pulled-right" v-model="charge.address_to">
                            <option value="1">Supplier</option>
                            <option value="2">Customer</option>
                          </select>
                        </p>
                        <p class="control">
                          <label class="label">Price</label>
                          <input :class="{'input': true, 'is-danger': errors.has('price')}" name="price" id="price" type="text" placeholder="" v-model="charge.price" v-validate="`required|decimal|min_value:1`">
                          <span v-show="errors.has('price')" class="help is-danger">{{ errors.first('price') }}</span>
                        </p>
                        <a style="margin-top: 25px;" v-if="occurrence.status !== 3 && !occurrence.financial_id" :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="saveCreDeb(charge.address_to)">Save Charge</a>
                      </div>
                    </div>
                    <div class="is-clearfix" v-if="([20].includes(parseInt(occurrence.subject_type)) && !occurrence.financial_id)">
                      <div class="control is-grouped">
                        <p class="control">
                          <label class="label">Type</label>
                          <select style="margin-right: 10px;" class="select is-pulled-right" v-model="charge.type">
                            <option value="1">Commission</option>
                            <option value="2">Cre/Deb</option>
                          </select>
                        </p>
                        <p class="control">
                          <label class="label">Price</label>
                          <input :class="{'input': true, 'is-danger': errors.has('price')}" name="price" id="price" type="text" placeholder="" v-model="charge.price" v-validate="`required|decimal|min_value:1`">
                          <span v-show="errors.has('price')" class="help is-danger">{{ errors.first('price') }}</span>
                        </p>
                        <a style="margin-top: 25px;" v-if="occurrence.status !== 3 && !occurrence.financial_id" :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="saveCreDeb(1)">Save Charge</a>
                      </div>
                    </div>
                </template>
                  <br/>
                  <p class="is-clearfix">
                    <a :class="{'button': true, 'is-info': true, 'is-pulled-left': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="internalTip" v-if="parseInt($store.state.config.user.level) < 4">Internal Tip</a>
                    <a :class="{'button': true, 'is-primary': true, 'is-pulled-right': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="replyOccurrence" v-if="occurrence.status != 3 && occurrence.status != 6">Reply</a>
                    <a style="margin-right: 10px;" :class="{'button': true, 'is-danger': true, 'is-pulled-right': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="replyCloseOccurrence" v-if="occurrence.status != 3 && occurrence.status != 6 && parseInt($store.state.config.user.level) < 4">Reply/Close</a>
                    <!-- VALIDATE CHARGE -->
                    <a :class="{'button': true, 'is-success': true, 'is-pulled-right': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}"
                      @click="validateCharge(true)"
                      v-if="occurrence.status == 6 && $store.state.config.user.validate_charges">
                      Approve
                    </a>
                    <a style="margin-right: 10px;" :class="{'button': true, 'is-danger': true, 'is-pulled-right': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}"
                      @click="validateCharge(false)"
                      v-if="occurrence.status == 6 && $store.state.config.user.validate_charges">
                      Not Approve
                    </a>
                    <!-- VALIDATE CHARGE -->
                    <a style="margin-right: 10px;" :class="{'button': true, 'is-warning': true, 'is-pulled-right': true, 'is-loading': inProgress, 'is-disabled': inProgress}" @click="replyAnalysis" v-if="occurrence.status < 3 && parseInt($store.state.config.user.level) < 4">Under Analysis</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      <br>
      <dispute :service="service" v-if="((parseInt($store.state.config.user.level) == 3 || parseInt($store.state.config.user.level) == 2)) && (parseInt(service.dispute_v2) !== 0)" ></dispute>
      <br>
      <financial :service="service" v-if="parseInt($store.state.config.user.level) < 99"></financial>
      <br>
      <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel">
            <p class="panel-heading panel-heading-info" style="justify-content: space-between;">History Financial
              <button class="button is-success is-small" @click="loadHistoryFinancial()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history_financial === 1">
              <historyFinancial :service="service"></historyFinancial>
            </p>
          </div>
        </div>
      </div>
      <div class="columns" v-if="parseInt($store.state.config.user.level) < 99">
        <div class="column is-12">
          <div class="panel-success">
            <p class="panel-heading panel-heading-success" style="justify-content: space-between;">History Extend
              <button class="button is-info is-small" @click="loadHistoryExtend()">Load history</button>
            </p>
            <p class="panel-block" v-if="load_history_extend === 1">
              <historyExtend :service="service"></historyExtend>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import message from '../../utils/message'
  import Service from '../../components/services/Service.vue'
  import OccurrencesSimple from '../../components/occurrences/OccurrencesSimple.vue'
  import Financial from '../../components/services/Financial.vue'
  import Dispute from '../../components/services/V2/Dispute.vue'
  import HistoryFinancial from '../../components/services/HistoryFinancial.vue'
  import HistoryExtend from '../../components/services/HistoryExtend.vue'
  import Charge from '../../components/services/V2/Charge.vue'
  export default {
    data () {
      return {
        occurrence: null,
        reply: {
          occurrence_id: '',
          reply_id: '',
          reply: '',
          close: false,
          internal: false,
          analysis: false,
          attachments: 0
        },
        charge: {
          price: 0,
          type: 1,
          address_to: 1,
          service_id: null,
          occurrence_id: null
        },
        dispute: {
          address_to: 3
        },
        inProgress: false,
        dropzoneOptions: {
          url: this.$store.state.config.apiURL + '/occurrences/reply/files',
          maxFilesize: 10,
          acceptedFiles: 'image/*,application/pdf,.doc,.docx,.csv,.xls,.xlsx,.txt,.eml,.log,.xml,.json',
          autoProcessQueue: false,
          dictDefaultMessage: 'Upload Files (max size 10MB)',
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.config.token.access_token
          },
          addRemoveLinks: true
        },
        showFiles: false,
        occurrence_files: [],
        service: null,
        reload: false,
        error: '',
        load_history_financial: 0,
        load_history_extend: 0
      }
    },
    components: {
      Service,
      OccurrencesSimple,
      Financial,
      Dispute,
      HistoryFinancial,
      HistoryExtend,
      vueDropzone: vue2Dropzone,
      Charge
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.$root.$on('reloadoccurrence', reload => {
          this.loadData()
        })
      })
    },
    methods: {
      loadHistoryFinancial () {
        this.load_history_financial = 1
        return this.load_history_financial
      },
      loadHistoryExtend () {
        this.load_history_extend = 1
        return this.load_history_extend
      },
      saveCreDeb (type) {
        if (window.confirm('Are you sure want to save charge?')) {
          // this.$validator.validateAll().then(() => {
          //   if (this.errors.items.length === 0) {
          this.inProgress = true
          let charge = {
            price: this.charge.price,
            type: parseInt(this.charge.type),
            service_id: this.occurrence.service_id,
            occurrence_id: this.occurrence.id
          }
          if (parseInt(type) === 1) {
            this.$http.post(this.$store.state.config.apiURL + '/V2/charge/debcred_provider', charge).then((response) => {
              if (response.body.hasOwnProperty('error')) {
                this.error = response.body.description
              } else if (response.body === '1') {
                this.message('danger', 'Error', 'The Price value cannot be 0')
                this.inProgress = false
              } else {
                this.message('success', 'Success', 'Charge was opened for ticket #' + this.occurrence.id)
                window.location.reload()
                this.inProgress = false
                this.error = ''
              }
            })
          } else if (parseInt(type) === 2) {
            this.$http.post(this.$store.state.config.apiURL + '/V2/charge/debcred_customer', charge).then((response) => {
              if (response.body.hasOwnProperty('error')) {
                this.error = response.body.description
              } else if (response.body === '1') {
                this.message('danger', 'Error', 'The Price value cannot be 0')
                this.inProgress = false
              } else {
                this.message('success', 'Success', 'Charge was opened for ticket #' + this.occurrence.id)
                window.location.reload()
                this.inProgress = false
                this.error = ''
              }
            })
          }
          //   }
          // })
        }
      },
      // reloadHistoryFinancial () {
      //   this.reload_history_financial = !this.reload_history_financial
      // },
      // reloadDispute () {
      //   this.reload_dispute = !this.reload_dispute
      // },
      openDispute () {
        if (window.confirm('Are you sure want to open dispute?')) {
          let dispute = {
            message: this.occurrence.occurrence,
            service_id: this.occurrence.service_id,
            occurrence_id: this.occurrence.id,
            address_to: parseInt(this.dispute.address_to)
          }
          this.$http.post(this.$store.state.config.apiURL + '/V2/dispute', dispute).then((response) => {
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.description
            } else {
              let reply = {
                occurrence_id: this.occurrence.id,
                reply: 'A dispute was opened for ticket #' + this.occurrence.id + ' to the financial department',
                close: false,
                internal: false,
                analysis: false,
                attachments: 0
              }
              this.$http.post(this.$store.state.config.apiURL + '/occurrences_customer_reply', reply).then((response) => {
              }, (response) => {
                this.inProgress = false
                this.message('danger', 'Error', response.body)
              })
              this.error = ''
              this.loadData()
              window.location.reload()
            }
          })
        }
      },
      clearReply () {
        this.reply.reply_id = ''
        this.reply.reply = ''
        this.reply.close = false
        this.reply.internal = false
        this.reply.analysis = false
        this.inProgress = false
        this.$validator.reset()
        this.$refs.dropzone.removeAllFiles(true)
        this.loadData()
      },
      loadData () {
        this.$http.get(this.$store.state.config.apiURL + '/occurrences_customer/' + this.$route.params.id).then((response) => {
          this.occurrence = response.body
          this.reply.occurrence_id = this.occurrence.id
          this.$http.get(this.$store.state.config.apiURL + '/services/' + this.occurrence.service_id).then((response) => {
            this.service = response.body
          }, (response) => {
            let propsData = {
              title: 'Error',
              message: response.body,
              type: 'danger',
              direction: 'down',
              duration: 4500,
              showCloseButton: true
            }
            message.openMessage(propsData)
            return '#/services/client'
          })
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      loadFiles () {
        this.$http.get(this.$store.state.config.apiURL + '/occurrences/files', {params: {'occurrence_id': this.occurrence.id}}).then((response) => {
          this.occurrence_files = response.body
          this.showFiles = true
        }, (response) => {
        })
      },
      loadFilesReply (reply, index) {
        this.$http.get(this.$store.state.config.apiURL + '/occurrences/reply/files', {params: {'occurrence_id': this.occurrence.id, 'reply_id': reply.id}}).then((response) => {
          this.occurrence.replies[index].files = response.body
          this.occurrence.replies[index].showFiles = true
        }, (response) => {
        })
      },
      vdSuccess (file, xhr, formData) {
        this.$emit('reload')
        if (this.reply.close) {
          this.message('success', 'Success', 'The reply successfully registered and occurrence closed')
        } else if (this.reply.internal) {
          this.message('success', 'Success', 'The internal tip was successfully registered')
        } else {
          this.message('success', 'Success', 'The reply successfully registered')
        }
        this.clearReply()
      },
      vdSendingEvent (file, xhr, formData) {
        formData.append('occurrence_id', this.reply.occurrence_id)
        formData.append('reply_id', this.reply.reply_id)
      },
      replyOccurrence () {
        if (window.confirm('Are you sure want to REPLY to this ticket?')) {
          this.$validator.validateAll().then(() => {
            if (this.errors.items.length === 0) {
              this.inProgress = true
              this.reply.close = false
              this.reply.internal = false
              this.reply.analysis = false
              if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                this.reply.attachments = 1
              }
              this.$http.post(this.$store.state.config.apiURL + '/occurrences_customer_reply', this.reply).then((response) => {
                this.reply.reply_id = response.body.id
                if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                  this.$refs.dropzone.processQueue()
                } else {
                  this.message('success', 'Success', 'The reply successfully registered')
                  this.clearReply()
                }
              }, (response) => {
                this.inProgress = false
                this.message('danger', 'Error', response.body)
              })
            }
          })
        }
      },
      // Metodo para reabrir ticket
      reopenOccurrence () {
        if (window.confirm('Are you sure want to REOPEN this ticket?')) {
          this.inProgress = true
          this.reply.close = false
          this.reply.internal = false
          this.reply.analysis = false
          this.$http.post(this.$store.state.config.apiURL + '/occurrences_customer/' + this.reply.occurrence_id + '/open').then((response) => {
            this.message('success', 'Success', 'The ticket was successfully reopened')
            this.clearReply()
          }, (response) => {
            this.inProgress = false
            this.reply.close = true
            this.message('danger', 'Error', response.body)
          })
        }
      },
      replyCloseOccurrence () {
        if (window.confirm('Are you sure want to CLOSE this ticket?')) {
          this.$validator.validateAll().then(() => {
            if (this.errors.items.length === 0) {
              this.inProgress = true
              this.reply.close = true
              this.reply.internal = false
              this.reply.analysis = false
              if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                this.reply.attachments = 1
              }
              this.$http.post(this.$store.state.config.apiURL + '/occurrences_customer_reply', this.reply).then((response) => {
                this.reply.reply_id = response.body.id
                if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                  this.$refs.dropzone.processQueue()
                } else {
                  this.message('success', 'Success', 'The reply successfully registered and occurrence closed')
                  this.clearReply()
                }
              }, (response) => {
                this.inProgress = false
                this.message('danger', 'Error', response.body)
              })
            }
          })
        } else {
          this.inProgress = false
        }
      },
      validateCharge (approval) {
        let warning = ''
        if (approval === true) {
          warning = 'Are you sure want to APPROVE the charge?'
        } else {
          warning = 'Are you sure want to NOT APPROVE the charge?'
        }
        if (window.confirm(warning)) {
          this.$http.post(this.$store.state.config.apiURL + '/V2/charge/validate_charge', {approval: approval, occurrence: this.occurrence.id}).then((response) => {
            this.message('success', 'Success', 'Option successfully saved, check at Charges section')
            this.inProgress = false
            setTimeout(() => {
              window.location.reload()
            }, 4000)
          }, (response) => {
            this.inProgress = false
            this.message('danger', 'Error', response.body, 60000)
          })
        } else {
          this.inProgress = false
        }
      },
      internalTip () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.reply.close = false
            this.reply.internal = true
            this.reply.analysis = false
            if (this.$refs.dropzone.getQueuedFiles().length > 0) {
              this.reply.attachments = 1
            }
            this.$http.post(this.$store.state.config.apiURL + '/occurrences_customer_reply', this.reply).then((response) => {
              this.reply.reply_id = response.body.id
              if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                this.$refs.dropzone.processQueue()
              } else {
                this.message('success', 'Success', 'The internal tip was successfully registered')
                this.clearReply()
              }
            }, (response) => {
              this.inProgress = false
              this.message('danger', 'Error', response.body)
            })
          }
        })
      },
      replyAnalysis () {
        this.inProgress = true
        this.reply.close = false
        this.reply.internal = false
        this.reply.analysis = true
        this.$http.post(this.$store.state.config.apiURL + '/occurrences_customer_reply', this.reply).then((response) => {
          this.clearReply()
          this.message('success', 'Success', 'The internal tip was successfully registered')
        }, (response) => {
          this.inProgress = false
          this.message('danger', 'Error', response.body)
        })
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      parseDepartament (departament) {
        return this.$store.state.config.departaments[departament].name
      },
      parseStatus (status) {
        return this.$store.state.config.status[status].name
      }
    },
    watch: {
      reload () {
        if (this.reload) {
          this.loadData()
        }
      },
      '$route' (to, from) {
        this.loadData()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  pre {
    background-color: #FFFFFF;
    white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
  }

  .tip {
    box-shadow: 0 2px 3px #2366d1, 0 0 0 1px #2366d1;
  }

  #customdropzone {
    background-color: orange;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #777;
    transition: background-color .2s linear;
    height: 200px;
    padding: 40px;
  }

  #customdropzone .dz-preview {
    width: 160px;
    display: inline-block
  }
 #customdropzone .dz-preview .dz-image {
    width: 80px;
    height: 80px;
    margin-left: 40px;
    margin-bottom: 10px;
  }
  #customdropzone .dz-preview .dz-image > div {
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background-size: contain;
  }
  #customdropzone .dz-preview .dz-image > img {
    width: 100%;
  }

   #customdropzone .dz-preview .dz-details {
    color: white;
    transition: opacity .2s linear;
    text-align: center;
  }
  #customdropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }

  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-success {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(35, 209, 96), 0px 0px 0px 1px rgb(35, 209, 96);
    color: #23d160;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-success {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(35, 209, 96), 0px 0px 0px 0px rgb(35, 209, 96);
    background-color: rgb(35, 209, 96);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-heading-card {
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-info {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(50, 115, 220), 0px 0px 0px 1px rgb(50, 115, 220);
    color: #3273dc;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-info {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(50, 115, 220), 0px 0px 0px 0px rgb(50, 115, 220);
    background-color: rgb(50, 115, 220);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }

  .panel-warning {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(255, 221, 87), 0px 0px 0px 1px rgb(255, 221, 87);
    color: #ffdd57;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading-warning {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: block;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(255, 221, 87), 0px 0px 0px 0px rgb(255, 221, 87);
    background-color: rgb(255, 221, 87);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Occurrence.vue?92392d88